import { useEffect, useState } from "react";
import { Container, Form, Row, Button } from "react-bootstrap";
import { toast } from "wc-toast";
import { apiGet, apiPost } from "../utils/apiFetch";
import pathObj from "../utils/apiPath";
import { isEmpty } from "lodash";
import Multiselect from "multiselect-react-dropdown";
import CasinoUpdateDialogBox from "../components/CasinoUpdateDialogBox";
const TransferAgent = () => {
  const [data, setData] = useState([]);
  const [user, setUser] = useState([]);
  const [userList, setUserList] = useState([]);
  const [from, setFrom] = useState([]);
  const [to, setTo] = useState([]);
  const [show, setShow] = useState(false);
  const [isLoader, setisLoader] = useState(false);
  const getData = async () => {
    try {
      const { status, data: response_users } = await apiGet(
        pathObj.getagentList
      );
      if (status === 200) {
        if (response_users.success) {
          setData(
            response_users?.results?.map((res) => {
              return { name: res?.username, id: res?._id };
            })
          );
        }
      }
    } catch (error) {}
  };
  const getDataUser = async (id) => {
    try {
      const { status, data: response_users } = await apiGet(
        pathObj.userList + "?agentId=" + id
      );
      if (status === 200) {
        if (response_users.success) {
          setUserList(
            response_users?.results?.map((res) => {
              return { name: res?.username, id: res?._id };
            })
          );
          setTo([]);
          setUser([]);
        }
      }
    } catch (error) {}
  };
  const submit = async () => {
    setisLoader(true);
    try {
      const { status, data: response_users } = await apiPost(
        pathObj.submitAgentTransfer,
        { fromAgent: from[0].id, toAgent: to[0].id, user: user[0].id }
      );
      if (status === 200) {
        if (response_users.success) {
          toast.success(response_users.message);
          setUserList([]);
          setFrom([]);
          setTo([]);
          setUser([]);
          setShow(false)
        }
      }
    } catch (error) {}
    setisLoader(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <section className="set-limit-sec py-4">
      <Container fluid>
        <h4 className="page-title">Transfer User</h4>
        <Row
          style={{
            padding: "10px",
            marginBottom: "0",
            marginLeft: "0",
            marginRight: "0",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Form.Group
              className="d-flex align-items-start"
              style={{ flexDirection: "column", marginRight: "20px" }}
            >
              <Form.Label>From Agent</Form.Label>
              <Multiselect
                singleSelect={true}
                showArrow={true}
                options={data}
                isObject={true}
                showSearch={true}
                selectedValues={from || []}
                onSelect={(selectedList, selectedItem) => {
                  setFrom(selectedList);
                  getDataUser(selectedItem?.id);
                }}
                onRemove={(selectedList, removedItem) => {
                  {
                    setFrom(selectedList);
                    setUser([]);
                    setUserList([]);
                  }
                }}
                placeholder="Select an option"
                displayValue="name"
              />
            </Form.Group>{" "}
            <Form.Group
              className="d-flex align-items-start"
              style={{ flexDirection: "column", marginRight: "20px" }}
            >
              <Form.Label>User</Form.Label>
              <Multiselect
                singleSelect
                showArrow={true}
                options={userList}
                selectedValues={user || []}
                onSelect={(selectedList, selectedItem) => {
                  setUser(selectedList);
                }}
                onRemove={(selectedList, removedItem) => {
                  setUser(selectedList);
                }}
                displayValue="name"
              />
            </Form.Group>
            <Form.Group
              className="d-flex align-items-start"
              style={{ flexDirection: "column", marginRight: "20px" }}
            >
              <Form.Label>To Agent</Form.Label>
              <Multiselect
                singleSelect
                disable={!isEmpty(from) && !isEmpty(user) ? false : true}
                showArrow={true}
                options={data?.filter((res) => {
                  return res?.id != from[0]?.id;
                })}
                selectedValues={to || []}
                onSelect={(selectedList, selectedItem) => setTo(selectedList)}
                onRemove={(selectedList, removedItem) => {
                  setTo(selectedList);
                }}
                displayValue="name"
              />
            </Form.Group>
            <Button
              className="theme_light_btn"
              style={{ alignSelf: "end", padding: "6px 10px" }}
              onClick={() => setShow(true)}
            >
              Submit
            </Button>
          </div>{" "}
        </Row>
      </Container>
      <CasinoUpdateDialogBox
        open={show}
        onClose={() => setShow(false)}
        onSubmit={submit}
        isLoader={isLoader}
        headerTitle={"Confirm Transfer"}
        title={` You Want to transfer ${user[0]?.name} from ${from[0]?.name} -> ${to[0]?.name}`}
      />
    </section>
  );
};

export default TransferAgent;
